var app = angular.module("leonardo");

var WorkFlowInstanceController = function($scope, $rootScope, $filter, $timeout, ngDialog, WorkFlowInstanceService,
                                          PermissionService, TaskService, TemplateService, ConfigThemeService) {
  $scope.items = [];
  $scope.expanded = false;
  $scope.workflow = $scope.$parent.workflow;
  $scope.tree_items = [];
  $scope.workflowProgress = 0;
  $scope.permissionService = PermissionService;
  $scope.templateService = TemplateService;

  $scope.workFlowInstanceService = WorkFlowInstanceService;

  $scope.orderTemplates = function(templates) {
    var templates_aux = angular.copy(templates);
    angular.forEach(templates_aux, function(template) {
      if(template.templates)
        template.templates = $scope.orderTemplates(template.templates);
    });
    return $filter('orderBy')(templates_aux, 'action_item.id');
  };

  $scope.concatTemplates = function(templates, results) {
    angular.forEach(templates, function(template) {
      results.push(template);
      if(template.templates)
        results.concat($scope.concatTemplates(template.templates, results));
    });
    return results;
  };

  $scope.initTemplates = function(templates) {
    templates = $filter('orderBy')(templates, 'follow_on_level', true);
    angular.forEach(templates, function(value){
      var follow_on = value.follow_on || value.parent_action_item;
      if (follow_on) {
        angular.forEach(templates, function(parent){
          var parent_id = value.follow_on ? parent.id : parent.action_item.id;
          if (parent_id == follow_on){
            if (!parent.templates) {
              parent.templates = [];
            }
            parent.templates.push(value);
          }
        });
      }
    });
    var templates_aux = [];
    angular.forEach(templates, function(value) {
      if (!value.follow_on && !value.parent_action_item) {
        templates_aux.push(value);
      }
    });
    $scope.tree_items = $scope.orderTemplates(templates_aux);
    return $scope.concatTemplates($scope.tree_items, []);
  };

  $scope.getClassItem = function(item) {
    var classes = [];
    if (item.follow_on || item.parent_action_item){
     classes.push('child');
     classes.push(item.follow_on_level);
    }
    return classes;
  };

  $scope.tabbItems = function() {
    angular.forEach(angular.element('.child'), function(value){
      var classes = value.classList;
      var follow_level = classes[classes.length-2];
      var padding = 10 + (follow_level*10);
      angular.element(value).css({paddingLeft: padding});
    });
  };

  $scope.expand = function() {
    if ($scope.expanded) {
      $scope.expanded = false;
      return;
    }
    $scope.expanded = true;
    $timeout($scope.tabbItems, 0);
  };

  $scope.calculateWorkflowProgress = function() {
    var cont = 0;
    angular.forEach($scope.items, function(item) {
      if (item.action_item && ((item.action_item.workflow_status == TaskService.WORKFLOW_STATUS_SOLVED) ||
        (item.action_item.workflow_status == TaskService.WORKFLOW_CANNOT_DO) || (item.action_item.workflow_status == TaskService.WORKFLOW_STATUS_APPROVAL_REJECTED))) {
        cont ++;
      }
    });
    $scope.workflowProgress = cont/$scope.items.length;
    $scope.workflowProgress = Number($scope.workflowProgress.toString().match(/^\d+(?:\.\d{0,4})?/));
  };

  $scope.refresh = function() {
    var workflow_templates = angular.copy($scope.workflow.active_templates);
    workflow_templates = workflow_templates.concat($scope.workflow.trigger_templates);
    $scope.items = $scope.initTemplates(workflow_templates);
    $scope.calculateWorkflowProgress();
  };

  $scope.getOptions = function(workflow) {
    if ( workflow.status == WorkFlowInstanceService.STATUS_CANCEL ) {
      return {color: ConfigThemeService.getColor('tertiaryColor', 0.2)};
    }
    else {
      return {color: ConfigThemeService.config.theme_config.successColor};
    }
  };

  $scope.isPending = function(workflow) {
    return _.contains([WorkFlowInstanceService.STATUS_PENDING, WorkFlowInstanceService.STATUS_STARTED], workflow.status.toString());
  };

  $scope.showWorkflowStopDialog = function(workflow) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/stop-instance.html',
      controller: 'WorkflowInstanceStopDialog',
      data: {
        workflow: workflow
      }
    }).then(function(){
      $rootScope.$broadcast('workflow-instance:updated');
    }, function () {
      return;
    });
  };

  $scope.showWorkflowDeleteDialog = function(workflow) {
    WorkFlowInstanceService.get(workflow.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: data,
          type: 'workflow'
        }
      }).then(function(resp){
        $rootScope.$broadcast('workflow-instance:removed');
      }, function () {
        return;
      });
    });
  };

  $scope.showWorkflowEditDialog = function(workflow) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/edit-instance.html',
      controller: 'WorkflowInstanceEditDialog',
      data: {
        workflow: workflow
      }
    }).then(function(){
      $rootScope.$broadcast('workflow-instance:updated');
    }, function () {
      return;
    });
  };

  $scope.showWorkflowLaunchDialog = function(workflow) {
    var items_ids = [];
    angular.forEach($scope.items, function(value){
        items_ids.push(value.id);
    });
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/launch.html',
      controller: 'LaunchWorkFlowDialog',
      data: {
        workflow: workflow,
        items: items_ids,
        property: workflow.property.id,
        unit: workflow.unit ? workflow.unit.id : null,
        workflow_id: workflow.workflow.id,
        context: workflow.workflow.by_unit ? 'Unit Workflow In Progress Page' : 'Workflow In Progress Page'
      }
    }).then(function(){
      $rootScope.$broadcast('workflow-instance:updated');
    });
  };

  $scope.getUnitInfo = function(unit) {
    if (!unit || !unit.number) return { building: '', unitNumber: '' };
    
    var numberStr = unit.number.toString();
    
    // Pattern is "Building - Number"
    if (numberStr.indexOf(' - ') > -1) {
      var parts = numberStr.split(' - ');
      return {
        building: parts[0],
        unitNumber: parts[1]
      };
    }
    
    // If no pattern found, assume it's just the unit number
    return {
      building: '',
      unitNumber: numberStr
    };
  };

  $scope.getUnitBuilding = function(unit) {
    return $scope.getUnitInfo(unit).building;
  };

  $scope.getUnitNumber = function(unit) {
    return $scope.getUnitInfo(unit).unitNumber;
  };

  $timeout(function () {
    $scope.refresh();
  }, 0);

};

app.controller('WorkFlowInstanceController', ['$scope', '$rootScope', '$filter', '$timeout', 'ngDialog', 'WorkFlowInstanceService',
  'PermissionService', 'TaskService', 'TemplateService', 'ConfigThemeService', WorkFlowInstanceController]);
